/** Dataset flag so we only attach one bubble listener per overlay container. */
const CONTAINER_GUARD = 'unisubsCtxGuard';

let documentCaptureInstalled = false;

function isSelectableSubtitleTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return Boolean(target.closest('#mainSub.selectable, #secondSub.selectable'));
}

function onDocumentContextMenuCapture(event: Event): void {
  if (!isSelectableSubtitleTarget(event.target)) return;
  event.stopPropagation();
}

/**
 * Keep the browser native context menu on selectable subtitle text.
 * Host players (YouTube) call preventDefault on contextmenu; stopping
 * propagation without preventDefault lets Copy / Search appear instead.
 */
export function attachNativeContextMenuGuard(container: HTMLElement): void {
  if (container.dataset[CONTAINER_GUARD] !== '1') {
    container.dataset[CONTAINER_GUARD] = '1';
    container.addEventListener('contextmenu', (event) => {
      event.stopPropagation();
    });
  }

  // Capture on document beats player ancestors that also listen in capture.
  if (!documentCaptureInstalled) {
    documentCaptureInstalled = true;
    document.addEventListener('contextmenu', onDocumentContextMenuCapture, true);
  }
}

/** Test-only: reset module singletons between cases. */
export function resetNativeContextMenuGuardsForTests(): void {
  if (documentCaptureInstalled) {
    document.removeEventListener('contextmenu', onDocumentContextMenuCapture, true);
  }
  documentCaptureInstalled = false;
}
